// extracted by mini-css-extract-plugin
module.exports = {"root":"Event_root__7UmIF","description":"Event_description__cdj8L","videoPlayer":"Event_videoPlayer__0Bbmi"};